import axios from 'axios';
import { useEffect, useState } from 'react';
import getAPI from '../../service/getAPI';
import { Button, Form } from 'react-bootstrap';
import { format } from 'date-fns';

const ResolvedQueryList = ({ search, setSearch }) => {
    const { master } = getAPI();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const [limit, setLimit] = useState(() => {
        // Get saved limit or default to 10
        const saved = localStorage.getItem("pageLimit");
        return saved ? parseInt(saved, 10) : 10;
    });

    useEffect(() => {
        // Store current limit in localStorage
        localStorage.setItem("pageLimit", limit);
    }, [limit]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    // const [search, setSearch] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    useEffect(() => {
        fetchData(page);
    }, [page, limit, search, fromDate, toDate]);

    const fetchData = async (currentPage) => {
        try {
            setLoading(true);
            const response = await axios.post(master.ResolveList, {
                page,
                limit,
                search,
                from_date: fromDate,
                to_date: toDate,
            });

            if (response.data.flag === 1 && response.data.code === 200) {
                const resData = response.data.data;
                const records = resData.data || [];
                // const pagination = resData.pagination || {};

                setData(records);
                // setTotalPages(pagination.totalPages || 1);
                // setPage(pagination.currentPage || currentPage);

                setTotalRecords(resData.pagination?.totalRecords || 0);
                setTotalPages(resData.pagination?.totalPages || 1);
            } else {
                setData([]);
                setTotalPages(1);
            }
        } catch (error) {
            console.error('Error fetching resolved queries:', error);
            setData([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return (
        <>
            {/* <main id="main" className="main"> */}
            {/* <div className="pagetitle">
                <h1>Resolved Queries</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Master</a></li>
                        <li className="breadcrumb-item active">Resolved</li>
                    </ol>
                </nav>
            </div> */}

            <Form className="row g-2 mb-3">
                <div className="col-md-3 gap-2">
                    <Form.Control
                        type="text"
                        placeholder="Search by mobile, remark etc."
                        value={search}
                        onChange={(e) => {
                            const input = e.target.value;
                            const cleaned = input.replace(/\s+/g, ''); // removes all whitespace
                            setSearch(cleaned);
                        }}
                    />
                </div>
                <div className="col-md-2">
                    <Form.Control
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className="col-md-2">
                    <Form.Control
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
                <div className="col-md-2 gap-2 d-flex">
                    <Button
                        variant="primary"
                        onClick={() => {
                            setPage(1);
                            // fetchData(page, limit);
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setSearch("");
                            setFromDate("");
                            setToDate("");
                            // setPage(1);
                            // fetchData(page, limit);                          
                        }}
                    >
                        Reset
                    </Button>
                </div>
            </Form>

            <div className="container-fluid p-0">
                {loading ? (
                    <div className="text-center my-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>No</th>
                                        <th>Customer Name</th>
                                        <th>Mobile No</th>
                                        <th>Address</th>
                                        <th>Resolution Type</th>
                                        <th>Remark</th>
                                        <th>Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item, index) => (
                                            <tr key={item.inquiry_id}>
                                                <td>{(page - 1) * perPage + index + 1}</td>
                                                <td>{item.customer_name || "-"}</td>
                                                {/* <td>{item.phone_number || "-"}</td> */}
                                                <td>{item.order_mobile_no || "-"}</td>
                                                <td>
                                                    {[
                                                        item.address,
                                                        item.state,
                                                        item.pincode,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(", ") || "-"}
                                                </td>
                                                <td>{item.resolution_type || "-"}</td>
                                                <td>{item.inquiry_remark || "-"}</td>
                                                <td>{item.created_at
                                                    ? format(new Date(item.created_at), "dd-MM-yyyy hh:mm a")
                                                    : "N/A"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <nav className="d-flex justify-content-between align-items-center mt-3">
                            <div>Total Records: {totalRecords}</div>

                            <div className="d-flex align-items-center gap-2">
                                <Form.Label className="mb-0 me-2">Show:</Form.Label>
                                <Form.Select
                                    value={limit}
                                    onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setPage(1);
                                    }}
                                    style={{ width: "100px" }}
                                >
                                    {[10, 25, 50, 100].map((num) => (
                                        <option key={num} value={num}>
                                            {num}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Button
                                    variant="primary"
                                    className="mx-2"
                                    disabled={page === 1}
                                    onClick={() => setPage(page - 1)}
                                >
                                    &laquo; Prev
                                </Button>

                                <Form.Select
                                    value={page}
                                    onChange={(e) => handlePageChange(Number(e.target.value))}
                                    style={{ width: "100px" }}
                                >
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                            Page {i + 1}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Button
                                    variant="primary"
                                    className="mx-2"
                                    disabled={page === totalPages}
                                    onClick={() => setPage(page + 1)}
                                >
                                    Next &raquo;
                                </Button>
                            </div>
                        </nav>

                    </>
                )}
            </div>
            {/* </main>
         */}
        </>
    );
};

export default ResolvedQueryList;
